<template>
    <main class="preprod">
        <section class="hero tw-w-full tw-relative">
            <div class="lg:tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div class="hero-text tw-flex tw-flex-col tw-items-center lg:tw-items-start tw-justify-end lg:tw-justify-center tw-text-center lg:tw-text-left">
                    <h1 class="tw-text-white">Bilan Auditif Gratuit<sup>1</sup></h1>
                    <h2 class="tw-text-white tw-mb-4 lg:tw-mb-0">Préservez votre <br>connexion au monde.</h2>
                </div>
                <div class="form-container tw-flex tw-justify-center lg:tw-justify-end">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>

        <section class="pourquoi">
            <div class="tw-container">
                <h1 class="tw-text-center">Pourquoi faire tester son audition ?</h1>
                <p class="tw-text-black tw-text-center tw-text-base lg:tw-text-lg">Tester sa vue et son cœur est devenu naturel. Tester son audition est tout aussi nécessaire, pourtant, c’est rarement un sujet abordé. Aujourd’hui, la perte auditive est un véritable enjeu de santé publique. À partir de 50 ans, une baisse d’audition est normale, il est important d’en parler et d’être accompagné afin d’éviter toute conséquence sur la santé.</p>
                <p class="tw-text-black tw-text-center tw-text-base lg:tw-text-lg">C’est pourquoi nous vous invitons à venir chez Amplifon pour profiter d’un bilan auditif gratuit et faire le point sur votre audition.</p>
                <div class="tw-flex tw-justify-center tw-items-center">
                    <button class="btn-page tw-uppercase tw-text-white tw-bg-black tw-w-full tw-text-2xl" v-scroll-to="'form'">J'en profite</button>
                </div>
            </div>
        </section>

        <section class="advantages">
            <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2">
                <div>
                    <h2 class="image-text tw-text-center">Bilan auditif<br>complet gratuit<sup>1</sup></h2>
                </div>

                <div>
                    <div class="tw-container">

                        <h2 class="tw-text-black tw-text-center lg:tw-text-left tw-pb-8">Les avantages <span class="tw-hidden lg:tw-inline">Amplifon</span></h2>
                        <p class="tw-text-black tw-text-base tw-pb-8 tw-text-center lg:tw-text-left">Avec 70 ans d’expertise dans l’audition, Amplifon dispose d’un vrai réseau de proximité de plus de <span>760 centres auditifs</span> en France.</p>
                        <h3 class="tw-text-center lg:tw-text-black lg:tw-text-left tw-text-xl tw-pb-8">L’expérience Amplifon c’est</h3>

                        <div class="list tw-pb-8">
                            <div class="advantage tw-flex tw-flex-col lg:tw-flex-row">
                                <div class="img tw-flex tw-justify-center tw-items-center lg:tw-justify-start">
                                    <img src="~@/assets/img/icons/free.svg">
                                </div>
                                <div class="text lg:tw-ml-8 lg:tw-text-left">
                                    <p class="tw-text-center tw-text-black lg:tw-text-left"><span>Un bilan auditif sur-mesure gratuit<sup>1</sup></span> et complet, parce que vos oreilles sont uniques.</p>
                                </div>
                            </div>

                            <div class="advantage tw-flex tw-flex-col lg:tw-flex-row">
                                <div class="img tw-flex tw-justify-center tw-items-center lg:tw-justify-start">
                                    <img src="~@/assets/img/icons/try.svg">
                                </div>
                                <div class="text lg:tw-ml-8 lg:tw-text-left">
                                    <p class="tw-text-center tw-text-black lg:tw-text-left"><span>Un essai gratuit pendant 30 jours<sup>2</sup></span> afin que vous puissiez essayer vos aides auditives dans votre environnement quotidien avant de vous décider.</p>
                                </div>
                            </div>

                            <div class="advantage tw-flex tw-flex-col lg:tw-flex-row">
                                <div class="img tw-flex tw-justify-center tw-items-center lg:tw-justify-start">
                                    <img src="~@/assets/img/icons/accompany.svg">
                                </div>
                                <div class="text lg:tw-ml-8 lg:tw-text-left">
                                    <p class="tw-text-center tw-text-black lg:tw-text-left"><span>Un accompagnement permanent</span>, inclus et illimité, pour optimiser les réglages de votre appareil et réaliser tous les contrôles nécessaires.</p>
                                </div>
                            </div>

                            <div class="advantage tw-flex tw-flex-col lg:tw-flex-row">
                                <div class="img tw-flex tw-justify-center tw-items-center lg:tw-justify-start">
                                    <img src="~@/assets/img/icons/solution.svg">
                                </div>
                                <div class="text lg:tw-ml-8 lg:tw-text-left">
                                    <p class="tw-text-center tw-text-black lg:tw-text-left"><span>Un vaste choix de solution auditives</span> parmi plus de 500 références, vous assurant de toujours trouver la meilleure solution.</p>
                                </div>
                            </div>
                        </div>

                        <div class="tw-flex tw-justify-center tw-items-center lg:tw-justify-start">
                            <button class="btn-page tw-uppercase tw-text-white tw-bg-black tw-w-full tw-text-2xl" v-scroll-to="'form'">J'en profite</button>
                        </div>

                        <div class="small-texts tw-text-center lg:tw-text-left">
                            <p class="tw-text-black"><sup>1</sup> Test à but non medical.</p>
                            <p class="tw-text-black"><sup>2</sup> Sur prescription médicale. Essai gratuit pendant 30 jours et sans engagement. Cette offre résulte d’une obligation légale.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
